var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99971 11.516C10.8339 11.516 11.5102 10.8398 11.5102 10.0056C11.5102 9.17137 10.8339 8.49512 9.99971 8.49512C9.16551 8.49512 8.48926 9.17137 8.48926 10.0056C8.48926 10.8398 9.16551 11.516 9.99971 11.516Z",
    fill: "#FFAB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5319 11.516C15.3661 11.516 16.0424 10.8398 16.0424 10.0056C16.0424 9.17137 15.3661 8.49512 14.5319 8.49512C13.6977 8.49512 13.0215 9.17137 13.0215 10.0056C13.0215 10.8398 13.6977 11.516 14.5319 11.516Z",
    fill: "#FFAB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46846 11.516C6.30266 11.516 6.97891 10.8398 6.97891 10.0056C6.97891 9.17137 6.30266 8.49512 5.46846 8.49512C4.63426 8.49512 3.95801 9.17137 3.95801 10.0056C3.95801 10.8398 4.63426 11.516 5.46846 11.516Z",
    fill: "#FFAB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.25C4.62352 0.25 0.25 4.62352 0.25 10C0.25 15.3765 4.62352 19.75 10 19.75C15.3765 19.75 19.75 15.3757 19.75 10C19.75 4.62428 15.3765 0.25 10 0.25ZM10 18.2395C5.4573 18.2395 1.76045 14.5435 1.76045 10C1.76045 5.45654 5.4573 1.76045 10 1.76045C14.5435 1.76045 18.2395 5.45654 18.2395 10C18.2395 14.5435 14.5427 18.2395 10 18.2395Z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingLogo);
export default __webpack_public_path__ + "static/media/pending-logo.f3a98e109e8862080e543e6dc0482dca.svg";
export { ForwardRef as ReactComponent };